import React, { useState } from 'react'
import { useSingleStoreAction } from '../../../hooks/store/store';
import LoadingErrorState from '../../ui/LoadingErrorState';
import FileUpload from '../../form/FileUpload';
import SubmitButton from '../../form/SubmitButton';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useUpdateResource } from '../../../hooks/useUpdateResource';
import LoadingButton from '../../form/LoadingButton';

export default function UpdateStoreProfile() {
    const {t} = useTranslation();
    const { storeId} = useParams<{ storeId: string}>();
    const numericStoreId = storeId ? parseInt(storeId):undefined;
    const {data:store,isError,isLoading} = useSingleStoreAction(numericStoreId);
    
      const [logoFile, setLogoFile] = useState<File | null>(null);
      const [coverFile, setCoverFile] = useState<File | null>(null);

       const { loading, updateResource } = useUpdateResource();
            
        const onSubmit = (e:React.FormEvent<HTMLFormElement>) => {
          e.preventDefault();
          // call API to create category
          const url =numericStoreId?`store/update-images?storeId=${numericStoreId}`:"store/update-images";
          const formData = new FormData();
          if(logoFile){
            formData.append("logo",logoFile);
          }
          if(coverFile){
            formData.append("cover",coverFile);
          }
          updateResource(url, formData,numericStoreId? "admin":"store",{
            method: "PUT",
            successMessage: t("update_success"),
            invalidateQueries:["store-detail-action"],
          });
        };
      
  return (
    <div>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
         
      {
        store &&
        <form
        onSubmit={(e)=>onSubmit(e)}
        className="flex flex-col gap-8 w-full max-w-lg mx-auto "
      >
        <FileUpload
          file={logoFile}
          setFile={setLogoFile}
          label={t("store_logo")}
          addText={t("add_logo")}
          shape="circle"
          size={128}
          initial={store?.logoUrl}
        />

        <FileUpload
          file={coverFile}
          setFile={setCoverFile}
          label={t("store_cover")}
          addText={t("add_cover")}
          shape="rectangle"
          size={192}
          initial={store?.coverUrl}
        />
        {
          loading
          ?
          <LoadingButton/>
          :
          <SubmitButton label='update'/>
        }
      </form>
      }
    </div>
  )
}
